import * as Sentry from '@sentry/vue'
import config from '@/config'
import util from '@/util'

const openChat = () => {
  if (window.$zoho) {
    // https://www.zoho.com/salesiq/help/developer-section/js-api-chat-start.html
    try {
      window.$zoho.salesiq.chat.start()
    } catch (e) {
      Sentry.captureException(e)
    }
  }
}

const hideChatBtn = () => {
  if (window.$zoho) {
    try {
      window.$zoho.salesiq.chatbutton.visible('hide')
      window.$zoho.salesiq.floatbutton.visible('hide')
      window.$zoho.salesiq.chatwindow.visible('hide')
      window.$zoho.salesiq.floatwindow.visible('hide')
    } catch (e) {
      Sentry.captureException(e)
    }
  }
}

const showChatBtn = () => {
  if (window.$zoho) {
    try {
      // window.$zoho.salesiq.chatbutton.visible('show')
      window.$zoho.salesiq.floatbutton.visible('show')
    } catch (e) {
      Sentry.captureException(e)
    }
  }
}

const identifyUser = (
  {
    id,
    email,
    plan,
    firstName,
    lastName,
  },
) => {
  if (!window.isZohoReady || !window.$zoho || !window.$zoho.salesiq) {
    // if zoho not ready yet, save for later
    window.zohoCustomerInfo = {
      id,
      email,
      plan,
      firstName,
      lastName,
    }
    return
  }
  try {
    if (firstName || lastName) {
      window.$zoho.salesiq.visitor.name(`${firstName} ${lastName}`)
    }
    if (email) {
      window.$zoho.salesiq.visitor.email(email)
    }
    window.$zoho.salesiq.visitor.info({
      Description: `UserId: ${id}`,
      Plan: plan,
    })
  } catch (error) {
    Sentry.captureException(error)
  }
}

const init = () => {
  const isEU = config.region === 'eu'
  const isWhiteLabel = util.checkWhiteLabelDomain()

  const ZOHO_SCRIPT_ID = 'zsiqscript'
  if (document.getElementById(ZOHO_SCRIPT_ID) || isEU || isWhiteLabel) {
    return
  }
  try {
    window.$zoho = window.$zoho || {}
    window.$zoho.salesiq = window.$zoho.salesiq || {
      widgetcode: 'siq638b670686866584f0086fbe033f57ec93f5090a9233b2f8097d4874a025be64',
      values: {},
      ready() {
        // AHA-8833, handle when zoho not loaded yet
        window.isZohoReady = true
        identifyUser(window.zohoCustomerInfo)
      },
    }
    const d = document
    const s = d.createElement('script')
    s.type = 'text/javascript'
    s.id = ZOHO_SCRIPT_ID
    s.defer = true
    s.src = 'https://salesiq.zohopublic.com/widget?wc=siq638b670686866584f0086fbe033f57ec93f5090a9233b2f8097d4874a025be64'
    const t = d.getElementsByTagName('script')[0]
    t.parentNode.insertBefore(s, t)
  } catch (e) {
    Sentry.captureException(e)
  }
}

export default {
  openChat,
  hideChatBtn,
  showChatBtn,
  identifyUser,
  init,
}
